import React from 'react';
import { SageHRCard } from './SageHRCard.component';
import { IntegrationDetailPageShell } from './IntegrationDetailPageShell.component';

export const SageHRDetailPage = () => (
  <IntegrationDetailPageShell
    logoText="SHR"
    logoColor="#00b188"
    title="Sage HR"
    subtitle="Push Prodaff tracked hours to Sage HR as timesheet entries."
  >
    <SageHRCard />
  </IntegrationDetailPageShell>
);
